import { FormControl, FormLabel, Typography } from '@mui/material'
import { createElement } from 'react'
import { ElementFactory, Question, Serializer } from 'survey-core'
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui'
import { SurveyFileUploadArea } from '../components/SurveyFileUploadArea'
import { handleSurveyFileSelect, deleteSurveyFile } from '../components/surveyFileHelpers'

const CUSTOM_TYPE = 'surveyfileupload'

export class SurveyFileUploadModel extends Question {
  constructor (name: string) {
    super(name)
    this.titleLocation = 'hidden'
  }

  getType (): string {
    return CUSTOM_TYPE
  }

  get uploadedFileName (): string | null {
    return this.getPropertyValue('uploadedFileName')
  }

  set uploadedFileName (val: string | null) {
    this.setPropertyValue('uploadedFileName', val)
  }

  get uploadedFileKey (): string | null {
    return this.getPropertyValue('uploadedFileKey')
  }

  set uploadedFileKey (val: string | null) {
    this.setPropertyValue('uploadedFileKey', val)
  }

  isEmpty (): boolean {
    return this.uploadedFileKey == null || this.uploadedFileKey === ''
  }

  handleFileSelect (file: File | undefined): void {
    handleSurveyFileSelect(this, file)
  }

  async deleteFile (): Promise<void> {
    await deleteSurveyFile(this)
  }
}

export function registerFileUploadQuestion (): void {
  ElementFactory.Instance.registerElement(
    CUSTOM_TYPE,
    (name) => {
      return new SurveyFileUploadModel(name)
    }
  )

  Serializer.addClass(
    CUSTOM_TYPE,
    [{
      name: 'uploadedFileName',
      type: 'string',
      category: 'general'
    }, {
      name: 'uploadedFileKey',
      type: 'string',
      category: 'general'
    }],
    function () {
      return new SurveyFileUploadModel('')
    },
    'question'
  )

  ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
    return createElement(SurveyQuestionFileUpload, props)
  })
}

export class SurveyQuestionFileUpload extends SurveyQuestionElementBase {
  get question (): SurveyFileUploadModel {
    return this.questionBase as SurveyFileUploadModel
  }

  handleDeleteFile = (): void => {
    void this.question.deleteFile()
  }

  renderElement (): JSX.Element {
    return (
      <FormControl>
        <FormLabel>
          {this.question.fullTitle}
          {!this.question.isRequired && (
            <Typography component="span" sx={{ fontStyle: 'italic', ml: 1 }}>
              optional
            </Typography>
          )}
        </FormLabel>
        {this.question.description != null && this.question.description !== '' && (
          <Typography sx={{ width: '80%', whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginY: '20px' }}>
            {this.question.description}
          </Typography>
        )}
        <SurveyFileUploadArea
          onFileSelect={(file) => { this.question.handleFileSelect(file) }}
          onDelete={this.handleDeleteFile}
          uploadedFileName={this.question.uploadedFileName}
          uploadedFileKey={this.question.uploadedFileKey}
        />
      </FormControl>
    )
  }
}
